import type { LayoutLoad } from './$types';
import { AsyncStatus } from '$lib/enums';
import { configStore } from '$lib/stores/config.svelte';
import { screenStore } from '$lib/stores/screen.svelte';
import { sessionStore } from '$lib/stores/session.svelte';

export const ssr = false;
export const prerender = false;
export const trailingSlash = 'always';

export const load: LayoutLoad = async ({ fetch }) => {
	sessionStore.init();
	screenStore.observe();
	if (configStore.status === AsyncStatus.IDLE) await configStore.load(fetch);
};
